import { SVGProps } from 'react';

const UserRoundSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 21a8 8 0 0 1 10.434-7.62M22 22l-1.9-1.9M15 8A5 5 0 1 1 5 8a5 5 0 0 1 10 0m6 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default UserRoundSearch;
